import { combineReducers } from 'redux';
import simple from './simple';
import login from './login';
import navbar from './navbar';
import modals from './modals';
import dashboard from './dashboard';
import orders from './orders';
import upload from './upload';
import safeCall from './safeCall';
import messages from './messages';
import transactions from './transactions';
import general from './general';

const appReducer = combineReducers({
    simple,
    login,
    navbar,
    modals,
    dashboard,
    orders,
    upload,
    safeCall,
    messages,
    transactions,
    general
});

const rootReducer = (state, action) => {
    return appReducer(state, action)
};

export default rootReducer;